import { useCallback, useState } from 'react';

/**
 * Open/close state for the share drawer. Shaped the same as
 * `useViewApproveRouteDrawer`, so the detail drawer can just call it
 * alongside the approval route drawer.
 */
export const useShareDrawer = () => {
  const [isOpen, setIsOpen] = useState(false);

  const onDrawerOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const onDrawerClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return { isOpen, onDrawerOpen, onDrawerClose };
};
